/**
 * Port any changes to 
 * \odsp-common\items-view\core\src\private\facets\LoggerFacets.ts
 * TODO: we will fix package dependencies to avoid duplication
 */
enum ClientId {
    unknown = 1,
    odb = 2,
    sharePoint = 3,
    ngsc = 4,
    word = 5,
    powerpoint = 6,
    excel = 7,
    onenoteWeb = 8,
    wac = 9,
    visio = 10,
    officecom = 11,
    listPart = 12, // SharePoint list web part
    outlookWeb = 13,
    odIos = 14,
    odAndroid = 15,
    teams = 16,
    sample = 17, // items-view demo code
    odc = 18,
    wordAndroid = 19,
    excelAndroid = 20,
    powerpointAndroid = 21,
    wordIos = 22,
    excelIos = 23,
    powerpointIos = 24,
    onenote = 25,
    teamsIos = 26,
    teamsAndroid = 27,
    onenoteIos = 28,
    visioIos = 29,
    onenoteAndroid = 30,
    visioAndroid = 31,
    outlookWindows = 32,
    outlookMac = 33,
    onenoteUWP = 34,
    officemobileIos = 35,
    officemobileAndroid = 36
}

/* Returns a ClientId value given its string value regardless of the casing */
export function getClientId(clientIdParam: string): ClientId {
    const clientIdParamFormatted = clientIdParam ? clientIdParam.toLowerCase() : '';

    switch (clientIdParamFormatted) {
        case 'odb':
            return ClientId.odb;
        case 'sharepoint':
            return ClientId.sharePoint;
        case 'ngsc':
            return ClientId.ngsc;
        case 'word':
            return ClientId.word;
        case 'powerpoint':
            return ClientId.powerpoint;
        case 'excel':
            return ClientId.excel;
        case 'onenoteweb':
            return ClientId.onenoteWeb;
        case 'wac':
            return ClientId.wac;
        case 'visio':
            return ClientId.visio;
        case 'officecom':
            return ClientId.officecom;
        case 'listpart':
            return ClientId.listPart;
        case 'outlookweb':
            return ClientId.outlookWeb;
        case 'odios':
            return ClientId.odIos;
        case 'odandroid':
            return ClientId.odAndroid;
        case 'teams':
            return ClientId.teams;
        case 'sample':
            return ClientId.sample;
        case 'odc':
            return ClientId.odc;
        case 'wordandroid':
            return ClientId.wordAndroid;
        case 'excelandroid':
            return ClientId.excelAndroid;
        case 'powerpointandroid':
            return ClientId.powerpointAndroid;
        case 'wordios':
            return ClientId.wordIos;
        case 'excelios':
            return ClientId.excelIos;
        case 'powerpointios':
            return ClientId.powerpointIos;
        case 'onenote':
            return ClientId.onenote;
        case 'teamsios':
            return ClientId.teamsIos;
        case 'teamsandroid':
            return ClientId.teamsAndroid;
        case 'onenoteios':
            return ClientId.onenoteIos;
        case 'visioios':
            return ClientId.visioIos;
        case 'onenoteandroid':
            return ClientId.onenoteAndroid;
        case 'visioandroid':
            return ClientId.visioAndroid;
        case 'outlookwindows':
            return ClientId.outlookWindows;
        case 'outlookmac':
            return ClientId.outlookMac;
        case 'onenoteuwp':
            return ClientId.onenoteUWP;
        case 'officemobileios':
            return ClientId.officemobileIos;
        case 'officemobileandroid':
            return ClientId.officemobileAndroid;
        default:
            return ClientId.unknown;
    }
}

export default ClientId;